import { render, staticRenderFns } from "./qianyan.vue?vue&type=template&id=6602fd00&scoped=true&"
import script from "./qianyan.vue?vue&type=script&lang=js&"
export * from "./qianyan.vue?vue&type=script&lang=js&"
import style0 from "./qianyan.vue?vue&type=style&index=0&id=6602fd00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6602fd00",
  null
  
)

export default component.exports